<script setup>
import Tooltip from '@/components/shared/core/Tooltip.vue'
import Icon from '@/components/shared/icons/Icon.vue'

defineProps({
  text: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <Tooltip
    :text="text"
    v-bind="$attrs"
  >
    <Icon
      icon="info"
      is-outlined
      size="xs"
    />
  </Tooltip>
</template>
